<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <div class="wf-checkbox-group">
            <label
                v-for="(option, index) in options"
                :key="index"
                class="wf-checkbox-item"
                :class="{ 'is-selected': isChecked(option) }"
            >
                <input
                    type="checkbox"
                    :value="option"
                    :checked="isChecked(option)"
                    @change="toggleOption(option)"
                />
                <span class="wf-checkbox-label">{{ option }}</span>
            </label>
        </div>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'CheckboxField',
    mixins: [FieldMixin],
    computed: {
        options() {
            if (!this.attribute.config || !this.attribute.config.options) return []
            return this.attribute.config.options[this.locale] || this.attribute.config.options['fr'] || []
        },
        selected() {
            return Array.isArray(this.value) ? this.value : []
        }
    },
    methods: {
        isChecked(option) {
            return this.selected.includes(option)
        },
        toggleOption(option) {
            const arr = [...this.selected]
            const idx = arr.indexOf(option)
            if (idx >= 0) {
                arr.splice(idx, 1)
            } else {
                arr.push(option)
            }
            this.emitValue(arr)
        }
    }
}
</script>
